<template>
  <div class="home flex-wrap flex-vertical">
    <!-- <van-nav-bar title="首页" :fixed="true" :placeholder="true" :safe-area-inset-top="true" /> -->

    <div class="flex-con home1">
      <!-- <img src="@/assets/logo.png" alt="龙蟠科技" class="logo" /> -->
      <div class="content">
        <div class="welcome">欢迎使用龙蟠科技正品查询平台 <br>Welcome to use Lopal Technology <br> Authentic Product Query Platform</div>

        <div class="button-container">
          <div class="button button-primary" @click="toMini">
            <div class="button-text1">中国大陆用户</div>
            <div class="button-subtext">请点此跳转微信小程序查询真伪</div>
          </div>
          <div class="button button-secondary" @click="toResult">
            <div class="button-text2">International users click <br />
              here to check authenticity</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { barcode } from '../api'
export default {
  name: 'HomeView',

  data() {
    return {
      fwcode: '',
      loading: false,
    }
  },

  mounted() {
    // 先拿 # 前面的参数
    const search = window.location.search.split('?')[1] || ''
    const params = new URLSearchParams(search)
    this.fwcode = params.get('fwcode') || ''
    

    // // 兼容原有写法
    // if (!this.fwcode) {
    //   this.fwcode = this.$route.query.fwcode || ''
    // }
  },

  methods: {
    toMini() { 
      const query = `fwCode=${encodeURIComponent(this.fwcode)}`;
      window.location.href = `weixin://dl/business/?appid=wx5a781a2bcfb6a538&path=pages/homeIn/homeIn&query=${encodeURIComponent(query)}`;
      
    },
    toResult() {
      if (this.loading) return;
      this.initCode()
    },
    initCode() {
      let _this = this
      _this.loading = true
      let params = {
        code: this.fwcode,
      }
      barcode(params).then((data) => {
        if (data.code == 200) {
          _this.$router.push({
            path: '/result',
            query: {
              id: data.data.id || '',
              codeStart: data.data.codeStart || '',
              codeFirstTime: data.data.codeFirstTime || '',
              codeSelectCount: data.data.codeSelectCount || '',
            },
          })
        }
      }).finally(() => {
        // 3秒后才允许再次提交
        setTimeout(() => {
          _this.loading = false
        }, 3000)
      })
    },
  },
}
</script>
<style scoped>

.button-text1{
  font-weight: 500;
font-size: 17px;
color: #333333;
line-height: 24px;
margin-bottom: 4px;
}


::v-deep.van-nav-bar__title {
  font-size: 18px;
  font-weight: 800;
}

::v-deep .van-nav-bar .van-icon {
  color: #333;
  font-size: 24px;
}

.home {
  height: 100vh;
}

.title1 {
  width: 100%;
  line-height: 50px;
  text-align: center;
  position: relative;
  background-color: #fff;
}

.home1 {
  background: url('@/assets/bg.png') no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 40px 20px; */
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.logo {
  width: 280px;
  max-width: 280px;
  height: 80px;
  margin: 80px auto 40px;
}

.content {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
}

.welcome {
  color: #fff;
  font-size: 16px;
  margin-top: 30vh;
  margin-bottom: 90px;
  text-align: center;
  line-height: 22px;
}

.button-container {
  margin: auto;
  box-sizing: border-box;
}

.button {
  box-sizing: border-box;
  color: #333;
  border-radius: 6px;
  padding: 20px 0 0 15px;
}

.button-primary {
  background-color: #fff;
  background-image: url('@/assets/img1.png');
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 139px 78px;
  margin-bottom: 12px;
  width: 276px;
  height: 87px;
}

.button-secondary {
  background-color: #fff;
  background-image: url('@/assets/img2.png');
  background-repeat: no-repeat;
  background-position: right top;
  background-size: 125px 77px;
  width: 276px;
  height: 79px;
}

.button-text2 {
  font-size: 18px;
  color: #333333;
  line-height: 20px;
}

.button-subtext {
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  font-weight: normal;
  color: #555;
}
</style>
